GameObject = require './gameObject'

class Tile extends GameObject
  constructor: (x, y, gridHelper, image) ->
    super x, y, gridHelper
    @drawable = image

module.exports = Tile
